// Balancing orifice vertex schema
// Simple passive device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, MeterMaterialSchema } from '../base/common';

export const BalancingOrificeVertexSchema = BaseVertexSchema.extend({
  type: z.literal('balancing_orifice'),
  elevation: ValueWithUnitSchema,
  meter_diameter: ValueWithUnitSchema,
  device_material: MeterMaterialSchema.optional(),
  pipe_material: MeterMaterialSchema.optional(),
});

export type BalancingOrificeVertex = z.infer<typeof BalancingOrificeVertexSchema>;
